export const DEFAULT_POLICY_TOPIC = "DISPLAY_POLICY_LISTING";
export const SUCCESS = "SUCCESS";
